module.exports = "<div class=\"alert-loading\">\n  <div class=\"alert-loading-content\">\n    <img src=\"assets/spinner-default.svg\" />\n  </div>\n</div>\n"